import React, { useState, useMemo, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const containsText = (text, searchText) =>
  text?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

export const MultiSelectCheckbox = (props) => {
  const { id, list, onChange, isDisabled, isSelectAll, selectedReportId } =
    props;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (id !== "reportId") {
      setSelectedOptions([]);
      onChange(id, id, []);
    }
  }, [selectedReportId]);

  const handleMenuItemClick = (optionId) => {
    if (optionId === "Select All") {
      const newSelectedOptions = selectAllChecked
        ? []
        : list.map((option) => option.id);
      setSelectedOptions(newSelectedOptions);
      setSelectAllChecked(!selectAllChecked);
      onChange(id, id, newSelectedOptions);
    } else {
      const selectedIndex = selectedOptions.indexOf(optionId);
      let newSelectedOptions = [];

      if (selectedIndex === -1) {
        newSelectedOptions = [...selectedOptions, optionId];
      } else {
        newSelectedOptions = selectedOptions.filter((id) => id !== optionId);
      }

      setSelectedOptions(newSelectedOptions);
      setSelectAllChecked(newSelectedOptions.length === list.length);
      onChange(id, id, newSelectedOptions);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedOptions(event.target.value);
    onChange(id, id, event.target.value);
  };

  const displayedOptions = useMemo(() => {
    if (!searchText) {
      return list;
    } else {
      return list.filter((option) => containsText(option.label, searchText));
    }
  }, [list, searchText]);

  const renderPlaceholder = () => {
    const selectedCount = selectedOptions.length;
    if (selectedCount < 4) {
      return list
        .filter((x) => selectedOptions.includes(x.id))
        ?.map((y) => y.label)
        ?.join(", ");
    } else {
      return selectedCount === list.length
        ? "All nodes selected"
        : selectedCount + " selected";
    }
  };

  return (
    <FormControl
      id={"formMulriSelectCheckBox_" + id}
      name={"formMulriSelectCheckBox_" + id}
      fullWidth
      disabled={isDisabled}
    >
      <Select
        MenuProps={{
          autoFocus: false,
          MenuListProps: {
            autoFocusItem: false,
          },
        }}
        labelId="search-select-label"
        id={id}
        multiple
        value={selectedOptions}
        size="small"
        label=""
        onChange={handleSelectChange} // Updated onChange handler
        onClose={() => setSearchText("")}
        renderValue={renderPlaceholder}
      >
        <ListSubheader>
          <TextField
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
          {isSelectAll && (
            <>
              <Checkbox
                sx={{ padding: "0px 4px 0px 0px" }}
                checked={selectAllChecked}
                onChange={() => handleMenuItemClick("Select All")}
              />
              Select All
            </>
          )}
        </ListSubheader>
        {displayedOptions.map((option) => (
          <MenuItem
            sx={{ p: 0, m: 0 }}
            key={option.id}
            value={option.id}
            onClick={() => handleMenuItemClick(option.id)}
          >
            <Checkbox
              sx={{ padding: "0px 4px 0px 16px" }}
              checked={selectedOptions.indexOf(option.id) !== -1}
            />
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
